import React from 'react'
import { useTranslation } from 'react-i18next'
import Mockup from "../assets/mockup-2.png"
const InvestmentProductsComponent = () => {
    const { t } = useTranslation();

    return (
        <div className='about-us-component-content investment-products-component-content'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-2">
                        <h4>{t('Yatırım Ürünleri')}</h4>
                    </div>
                    <div className="col-lg-6">
                        <h3 className='mb-4'>{t('Paragon Yatırım Ürünleri: Çeşitli Seçeneklerle Kârlı Yatırımlar')}</h3>
                        <p className="mb-2">
                            {t('Paragon Yatırım, her yatırımcının ihtiyaçlarına göre geniş bir yatırım ürünü yelpazesi sunar. Forex piyasasından hisse senetlerine, emtialardan kripto paralara kadar pek çok yatırım aracını tek bir platformda bulabilirsiniz. İster düşük riskli, ister daha yüksek getirili yatırımlar arayışında olun, Paragon size uygun seçenekler sunar.')}
                        </p>
                        <p className="mb-0">
                            {t('Yatırımcılarımıza sunduğumuz ürünler, gelişmiş analiz araçları ve hızlı işlem yapma imkânı ile desteklenir. Ayrıca, farklı hesap türleri ve stratejilerle yatırımcılarımızın risk profillerine en uygun ürünleri seçmelerini sağlıyoruz. Paragon Yatırım ile piyasalarda yerinizi alın ve yatırımlarınızı büyütün!')}
                        </p>
                    </div>
                    <div className="col-lg-4 mt-lg-0 mt-4" style={{ backgroundImage: 'url("https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/bg-line-circle-digipay.png")', backgroundColor: "#D8F6EE", borderRadius: 10, backgroundPosition: "center", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 50 }}>
                        <img src={Mockup} alt="" width="175px" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvestmentProductsComponent